<template>
    <div
        class="kpi-avatar-stack d-flex"
        style="margin-left:8px"
    >
        <div
            v-for="(avatar, i) in avatars"
            :key="i"
            :style="{
                width: '32px',
                height: '32px',
                borderRadius: '9999px',
                border: '2px solid #fff',
                background: avatar.color,
                color: avatar.text,
                fontSize: '10px',
                fontWeight: 700,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginLeft: i === 0 ? '0' : '-8px',
            }"
        >
            {{ avatar.label }}
        </div>
    </div>
</template>

<script>
export default {
    name: 'KpiAvatarStack',
    props: {
        items: {
            type: Array,
            default: () => [],
        },
        extra: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        avatars() {
            const palette = [
                { color: 'rgba(112, 42, 225, 0.2)', text: 'var(--color-primary)' },
                { color: 'rgba(100, 72, 178, 0.2)', text: 'var(--color-secondary)' },
                { color: 'rgba(95, 82, 146, 0.2)', text: 'var(--color-tertiary)' },
                { color: 'rgba(255, 255, 255, 0.4)', text: 'var(--color-on-surface)' },
            ]
            const list = this.items.map((it, i) => ({
                label: typeof it === 'string' ? it : it.label,
                color: (typeof it === 'object' && it.color) || palette[i % palette.length].color,
                text: (typeof it === 'object' && it.text) || palette[i % palette.length].text,
            }))
            if (this.extra > 0) {
                list.push({
                    label: `+${this.extra}`,
                    color: 'rgba(255,255,255,0.4)',
                    text: 'var(--color-on-surface)',
                })
            }
            return list
        },
    },
}
</script>
